import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, ButtonGroup, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import Calendar from 'assets/icon/calendar-icon.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import { Field, Formik } from 'formik';
import ReactSelect from 'react-select';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faL } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import Drawer from 'components/Drawer';
import { Option, LimitedChipsContainer } from 'components/Options';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import { ceil, clone, cloneDeep, iteratee } from 'lodash';
import { set } from 'lodash';
import NDCList from 'components/NDCList';
import { useAsync } from 'react-async';
import * as Yup from 'yup';

import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import Loader from 'components/Loader';




let hasDatePopupOpen = false;

let tableDataBackup = [
    {
        chainPharmacy: "123445",
        pharmacy: "123445",
        npi: "123445",
        ncpdPandNABP: "123445",
        pharmacyAddress: "123445",
        pharmacyLiveDate: "123445",
        pharmacyTerminationDate: "123445",
        claimsProcessDate: "123445",

    }
];

let coveredEntityError = 'Covered Entity is a required field';
let accumulatorError = 'Accumulator is a required field';
let rowForEdit = {};
let updatedFields = {};
let coveredEntitiesData = [];
let accumulationsData = [];
const validationSchema = Yup.object({
    //coveredEntityID: Yup.string().required('Please select covered entity'),
});

const SearchContainer = (props) => {
    const API = useAxios();
    const {
        states: { inventory },
        setStates,
        resetStates,
    } = useContextService();
    const { addCrosswalk, orgId, onSearch, onReset } = props;

    const [tableData, setTableData] = useState(tableDataBackup);
    const [data, setData] = useState(tableDataBackup);
    const [loading, setLoading] = useState(false);
    const [isSubmited, serIsSubmitted] = useState(false);
    const [hasCESelected, setCESelected] = useState(true);
    const [hasACSelected, setACSelected] = useState(true);
    const [showDetails, setShowDetails] = useState(true)
    const [collapseSider, setcollapseSider] = useState(false);
    const [collIcon, setCollIcon] = useState(faAngleUp);
    const [activeButton, setActiveButton] = useState("All");
    const [selectedCEOption, setCEOptionSelected] = useState({ optionCESelected: '-1' });
    const [selectedAccuOption, setAccuOptionSelected] = useState({ optionSelected: '-1' });
    const [selectedClaimType, setClaimTypeSelected] = useState();
    const [selectedNdc, setSelectedNdc] = useState('');
    const [selectedOpt, setOptSelected] = useState({ optSelected: '-1' });
    const [submit, setSubmit] = useState(false);

    const { accumulations, coveredEntity, searchTerms } = inventory;
    let {
        coveredEntityIDs,
        coveredEntityID,
        accumulationIDs,
        ndc,
        showClaimID
    } = searchTerms;

    const updateStates = (inventory) => {
        setStates('inventory', inventory);
    };
    useEffect(() => {
        setCESelected(true);
        setACSelected(true);
        coveredEntitiesData = [];
        accumulationsData = [];
        inventory.accumulations = [];
        inventory.searchTerms.coveredEntityIDs = {}
        inventory.searchTerms.accumulationIDs = {}
        updateStates(inventory);
        setCEOptionSelected({ optionCESelected: '-1' });
        setAccuOptionSelected({ optionSelected: '-1' });
        fetchCoveredEntities();
        setSelectedNdc('');
        serIsSubmitted(false);
    }, [orgId])

    const fetchCoveredEntities = async () => {
        //let { organizationID } = orgId;
        if (typeof orgId !== "undefined" && orgId !== null) {
            coveredEntitiesData = [];
            inventory.searchTerms.coveredEntityIDs = [];
            updateStates(inventory);

            let selectedOrgId = orgId.organizationID;

            setLoading(true);
            try {              
                const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
                    hasDefaultURL: true,
                });
                setLoading(true);
                if (data) {
                    for (var x in data) {
                        coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
                    }
                    inventory.coveredEntities = data;

                    if (coveredEntitiesData.length == 1) {
                        var ceData = [];
                        ceData.push(coveredEntitiesData[0]);
                        inventory.searchTerms.coveredEntityIDs = ceData;
                        window.selectedCoveredEntittyId = ceData;
                    }
                    
                    if (window.selectedCoveredEntittyId.length > 0) {
                        inventory.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
                    }

                    updateStates(inventory);
                    if (Array.isArray(inventory.searchTerms.coveredEntityIDs)) {

                        var ceSelected = [];
                        ceSelected.optionCESelected = [];
                        for (var x in inventory.searchTerms.coveredEntityIDs) {

                            ceSelected.optionCESelected.push(inventory.searchTerms.coveredEntityIDs[x]);
                        }
                        setCEOptionSelected(ceSelected);
                        let ceIds = inventory.searchTerms.coveredEntityIDs.map(item => item["value"]);
                        fetchAccumulatorName(ceIds);
                    }
                    setLoading(false);
                }
            }
            catch (err) {
                setLoading(true);
            }
        }

    };


    const handleCoverdEntityChange = (selectedces, setFieldValue, entity) => {

    let selected = [selectedces == null ? []: selectedces]

        if (selected) {
            window.selectedCoveredEntittyId = selected;
            window.selectedAccumulatorId = [];
            accumulationsData = [];
            // setSelectedNdc('');
            inventory.searchTerms.accumulationIDs = {};
            setCESelected(true);
            setCEOptionSelected({
                optionCESelected: selected.value
            });
            let val = selected.value;
            inventory.coveredEntities = selected;
            setFieldValue('coveredEntityIDs', selected);
            inventory.searchTerms.coveredEntityIDs = selected;
            if (Array.isArray(inventory.searchTerms.coveredEntityIDs)) {
                accumulationIDs = {};
                inventory.searchTerms.accumulationIDs = {};
            }
            let ceIds = inventory.searchTerms.coveredEntityIDs.map(item => item["value"]);
            inventory.searchTerms.coveredEntityIDs = ceIds;
            updateStates(inventory);
            fetchAccumulatorName(ceIds);
            setAccuOptionSelected({ optionSelected: '-1' });
        }
        else {
            setFieldValue('coveredEntityIDs', {});
            accumulationsData = [];
            inventory.coveredEntities = [];
            inventory.searchTerms.coveredEntityIDs = {};
            inventory.searchTerms.accumulationIDs = {};
            setCESelected(false);
            setACSelected(false);
        }
        onReset()
        updateStates(inventory);
    };

    const fetchAccumulatorName = async (coveredEntityIDs) => {       
        if (coveredEntityIDs !== undefined && coveredEntityIDs.length > 0) {
            try {
                accumulationsData = [];
                const payload = [];
                payload.AccumulatorEntityList = [coveredEntityIDs[0]];
                let AccumulatorEntityList = [payload.AccumulatorEntityList]
                const data = await API.get(`SBConfig/coveredentity/acclist/${AccumulatorEntityList}`,
                    {
                        hasDefaultURL: true,
                    }
                );
               
                if (data) {
                    let accumulator = [];
                    accumulator = data.data;
                    for (var x in accumulator) {
                        accumulationsData.push({ "value": accumulator[x].accumulatorID, "label": accumulator[x].ceName });
                    }console.log(accumulationsData,"accumulationsData printing")
                 
                 
                 if (accumulationsData.length == 1) {
                    handleAccumulatorname(accumulationsData[0]);
                  }
                //  else if (window.selectedAccumulatorId.length > 0) {
                //     inventory.searchTerms.accumulationIDs =
                //       window.selectedAccumulatorId;
                //       handleAccumulatorname(window.selectedAccumulatorId[0]);
                //   }

                    inventory.accumulations = data.data;
                    updateStates(inventory);

                    // if(accumulationIDs.length > 0){
                    //     var accumulatorSelected = {};
                    //     accumulatorSelected.optionSelected = [];
                    // for (var x in accumulationIDs) {
                    //   accumulatorSelected.optionSelected.push(accumulationIDs[x]);
                    // }
                    // setAccuOptionSelected({accumulatorSelected});
                    // }
                    // if (accumulationIDs) {
                    //     var accumulatorSelected = {};
                    //     accumulatorSelected.optionSelected = [];
                    //     for (var x in accumulationIDs) {
                    //         accumulatorSelected.optionSelected.push(accumulationIDs[x]);
                    //     }
                    //     setAccuOptionSelected({ optionSelected: '-1' });
                    // }
                }
            } catch (error) {
                console.log(error.message);
            }
        }
    };

    const handleAccumulatorname = (selectedces, setFieldValue, ac) => {

        let selected = [selectedces == null?[]:selectedces]
        window.selectedAccumulatorId = selected;
        if (selected) {
            setACSelected(true);
            setAccuOptionSelected({
                optionSelected: selected
            })
            // let val = selected.value;
            // setFieldValue('accumulationIDs', val);
            // setFieldValue('accumulationIDs', selected);
            inventory.searchTerms.accumulationIDs = selected;
            handleSubmit(searchTerms);
        }
        else {
            setACSelected(true);
            setFieldValue('accumulationIDs', {});
            accumulationsData = [];
            inventory.coveredEntities = [];
            inventory.searchTerms.accumulationIDs = {};
            inventory.searchTerms.coveredEntityIDs = {};
            setCESelected(false);
        }
        updateStates(inventory);
    };

    const toggleSider = () => {
        setcollapseSider(!collapseSider);
        if (!collapseSider) {
            setCollIcon(faAngleDown);
        }
        else {
            setCollIcon(faAngleUp);
        }
    }
    const handelAddCrosswalk = async () => {
        await addCrosswalk()
    }


    const renderEditButton = () => {
         if (hasPermission('ED'))
        return <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => ""}
            title='Edit Covered Entity'

        >
            <HoverImage src={EditIcon}
                hoverSrc={EditHoverIcon}
                alt='' />
        </Button>
    }
    const cellRenderEdit = (rowData) => {

        if (rowData.isEdit) {
            return (
                <div className='d-flex align-items-center'>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={savePanelUpdateRow}
                    >
                        <HoverImage
                            key='SaveIcon'
                            src={SaveIcon}
                            hoverSrc={SaveHoverIcon}
                            alt=''
                        />
                    </Button>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={() => editRow(rowData, false)}
                    >
                        <HoverImage
                            key='CancelIcon'
                            src={CancleIcon}
                            hoverSrc={CancleHoverIcon}
                            alt=''
                        />
                    </Button>
                </div>
            );
        } else {

            return (
                <div className='d-flex align-items-center'>
                    {renderEditLButton1(rowData)}

                </div>
            );
        }
    };
    const renderEditLButton1 = (rowData) => {
        // if (hasPermission('EPLS'))
        return <Button
            className='text-primary p-0 text-decoration-none'
            color='link'

            onClick={() => editRow(rowData)}
            title='Edit'


        >
            <HoverImage src={EditIcon}
                hoverSrc={EditHoverIcon}
                alt='' />
        </Button>
    }
    const editRow = (rowData, isEdit = true) => {

        let tempData = [...data];
        tempData = tempData.map((row) => {
            row.isEdit = false;
            if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
                row.isEdit = isEdit;
                rowForEdit = row;
            }
            return row;
        });
        // setTouched('');
        // setSelectedStatus('');
        updatedFields = {};
        //  tableDataBackup = tempData;
        setData(tempData);
    };
    const savePanelUpdateRow = async () => {
        console.log("krishna")
    };
    const updateRowValue = (value, col) => {

        const tempRow = { ...rowForEdit };
        tempRow[col] = value;
        rowForEdit = tempRow;
    };
    const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {

        return (
            <CellEditRender
                row={row}
                col={col}
                formatterType={formatterType}
                onChange={updateRowValue}
                alwaysEditableCheckbox={alwaysEditableCheckbox}
            />
        );
    };

    // const handelAdd = () => {
    //     setShowDetails(false)
    // }
    // const handelCancel = () => {
    //     setShowDetails(true)
    // }
    // useEffect(() => {

    // }, [showDetails])
    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleDateClick = (id) => {

        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    const handleButtonClick = (button) => {
        setActiveButton(button);
    };
    const handleNdc = (ndc, setFieldValue) => {
        if (ndc !== null) {
            setSelectedNdc(ndc);
            setFieldValue('ndc', ndc.id);
            inventory.searchTerms.ndc = ndc.id.toString();
        }
        else {
            setSelectedNdc(null);
            setFieldValue('ndc', null);
            inventory.searchTerms.ndc = null;
        }
        updateStates(inventory);
    };

    const handleSubmit = async (val, actions) => {   
        debugger
        serIsSubmitted(true);
        let acIDs = [];
        let ceIDs = [];

        if (searchTerms.coveredEntityIDs.length > 0) {
            val.coveredEntityIDs = searchTerms.coveredEntityIDs;
            setCESelected(true);
        }
        if (searchTerms.accumulationIDs.length > 0) {
            val.accumulationIDs = searchTerms.accumulationIDs;
            setACSelected(true);
        }
        for (var x in val.accumulationIDs) {
            var ra = val.accumulationIDs[x];
            acIDs.push(ra.value);
        }
        for (var x in val.coveredEntityIDs) {
            var rw = val.coveredEntityIDs[x];
            ceIDs.push(rw);
        }
        if (ceIDs.length == 0 && acIDs.length == 0) {
            setCESelected(false);
            setACSelected(false);
            return true;
        }
        if (ceIDs.length > 0 && acIDs.length == 0) {
                setACSelected(false);
                return true;
            }
        
        const values = cloneDeep(val);
     
        if (selectedNdc) {
            values.ndc = selectedNdc.id;
        }
        else {
            values.ndc = '';
        }
   

        inventory.search.currentPage = 1;
        updateStates(inventory);
        await onSearch(values);
    };

    const handleReset = ({ resetForm }) => {
        debugger
        serIsSubmitted(false);
        setCESelected(true);
        setACSelected(true);
        setClaimTypeSelected('');
        setSelectedNdc('');
        accumulationsData = [];
        window.selectedCoveredEntittyId = "";
        window.selectedAccumulatorId = "";
        resetForm();
        onReset();
        setCEOptionSelected({ optionCESelected: '-1' });
        setAccuOptionSelected({ optionSelected: '-1' });
        inventory.searchTerms.coveredEntityIDs = {};
        inventory.searchTerms.accumulationIDs = {};
        updateStates(inventory);
        setOptSelected({ optSelected: '-1' });
        resetStates('inventory');
    }

    return (
        
        <div>
            <Formik
                initialValues={searchTerms}
                // initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
                enableReinitialize={true}
                children={(props) => {
                    const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                    return (
                      <div hidden={collapseSider}>
                        <div>
                          <h5 className="f-16 text-primary font-weight-700">
                            Search Accumulations
                          </h5>
                          <Row sm={5} className="d-flex" style={{}}>
                            <Col md={3} lg={3} sm={6} xs={6}>
                              {" "}
                              <FormGroup>
                                <Label for="coveredEntity">
                                  Covered Entity
                                </Label>
                                <ReactSelect
                                  name="coveredEntity"
                                  id="coveredEntity"
                                  options={coveredEntitiesData}
                                  //  isMulti
                                  // isOptionSelected={""}
                                  // closeMenuOnSelect={false}
                                  // hideSelectedOptions={false}
                                  // optionSelected={true}
                                  components={{
                                    Option,
                                  }}
                                  // isSearchable="true"
                                  onChange={(value, entity) =>
                                    handleCoverdEntityChange(
                                      value,
                                      setFieldValue,
                                      entity
                                    )
                                  }
                                  value={selectedCEOption.optionCESelected}
                                  className="claim_info required"
                                  // maxMenuHeight={220}
                                  styles={{
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 99,
                                    }),
                                    option: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }),
                                  }}
                                />
                                {!hasCESelected ? (
                                  <div className="text-danger f-12 position-absolute">
                                    {coveredEntityError}
                                  </div>
                                ) : null}
                              </FormGroup>
                            </Col>
                            <Col md={3} lg={3} sm={6} xs={6}>
                              {" "}
                              <FormGroup>
                                <Label for="accumulationIDs">Accumulator</Label>
                                <ReactSelect
                                  name="accumulationIDs"
                                  id="accumulationIDs"
                                  options={accumulationsData}
                                  isDisabled={accumulationsData.length == 1}
                                  //  isMulti

                                  // closeMenuOnSelect={false}
                                  // hideSelectedOptions={false}
                                  // optionSelected={true}
                                  components={{
                                    Option,
                                    // ValueContainer: LimitedChipsContainer
                                  }}
                                  // isSearchable="true"
                                  onChange={(value, ac) =>
                                    handleAccumulatorname(
                                      value,
                                      setFieldValue,
                                      ac
                                    )
                                  }
                                  value={selectedAccuOption.optionSelected}
                                  className="claim_info required"
                                  maxMenuHeight={220}
                                  styles={{
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 99,
                                    }),
                                    option: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }),
                                  }}
                                />
                                {(!hasACSelected && isSubmited) ||
                                (hasCESelected &&
                                  isSubmited &&
                                  selectedAccuOption.optionSelected == "-1") ? (
                                  <div className="text-danger f-12 position-absolute">
                                    {accumulatorError}
                                  </div>
                                ) : null}
                              </FormGroup>
                            </Col>
                            <Col md={3} lg={3} sm={6} xs={6}>
                              {" "}
                              <FormGroup>
                                <Label for="drugname">Drug Name/NDC </Label>
                                <NDCList
                                  requiredflag={false}
                                  onSelect={(value) =>
                                    handleNdc(value, setFieldValue)
                                  }
                                  selectedNDC={selectedNdc}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <div hidden={""}>
                          <Row
                            className="d-flex"
                            style={{ justifyContent: "flex-end" }}
                          >
                            <Col md="auto" className="">
                              <Label>{""}</Label>
                              <Button
                                // hidden={isAddPermission}
                                disabled={isSubmitting}
                                color="primary"
                                className="search ms-3"
                                onClick={handleSubmit}
                                // disabled={!coveredEntityid}
                                // hidden={!hasPermission("ADD")}
                              >
                                <span className="right_5">
                                  <img src={search} alt="" />
                                </span>{" "}
                                Search
                              </Button>
                              <Button
                                // hidden={isAddPermission}
                                // disabled={isSubmitting}
                                color="primary"
                                className="reset"
                                onClick={() => handleReset(props)}
                                // disabled={!coveredEntityid}
                                // hidden={!hasPermission("ADD")}
                              >
                                <span className="right_5">
                                  <img src={reseticon} alt="" />
                                </span>{" "}
                                Reset
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    );
                }}></Formik>
            {/* <div className="py-2 text-center">
                <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                    <FontAwesomeIcon icon={collIcon} className="fa-fw" />
                </span>
            </div> */}



        </div>
    )
}

export default SearchContainer
